module.exports = __webpack_public_path__ + "img/5-ilpakamaniotroMAS_thumb.a104b098.jpg";